import Component from '../../component/component';

import './number.scss';

export default class Number extends Component {
    static initSelector: string = '.number';

    input: HTMLInputElement;
    add: HTMLButtonElement;
    substract: HTMLButtonElement;
    min: string;
    max: string;
    quantitymultiplier: string;

    constructor(target: HTMLElement) {
        super(target);

        this.input = this.element.querySelector('.number__input');
        this.add = this.element.querySelector('.number__button--add');
        this.min = this.input.getAttribute('min');
        this.max = this.input.getAttribute('max');
        this.quantitymultiplier = this.input.getAttribute('data-quantity');
        this.substract = this.element.querySelector('.number__button--subtract');

        this.init();
    }

    init(): void {
        this.add.addEventListener('click', this.onAddClick.bind(this));
        this.substract.addEventListener('click', this.onSubstractClick.bind(this));

        this.checkButtons();
    }

    get value(): number {
        if (typeof this.input.value === 'number') {
            return this.input.value;
        } else if (typeof this.input.value === 'string') {
            return parseInt(this.input.value);
        } else {
            return 0;
        }
    }

    onAddClick(): void {
        const quantity: number = this.getQuantity();

        if ((parseInt(this.max) * quantity) !== this.value) {
            this.input.value = `${(this.value + (1 * quantity))}`;
            this.input.dispatchEvent(new Event('change'));
        }

        this.checkButtons();
    }

    onSubstractClick(): void {
        const quantity: number = this.getQuantity();

        if ((parseInt(this.min) * quantity) !== this.value) {
            this.input.value = `${(this.value - (1 * quantity))}`;
            this.input.dispatchEvent(new Event('change'));
        }

        this.checkButtons();
    }

    checkButtons(): void {
        const quantity: number = this.getQuantity();

        if (this.value === (parseInt(this.min) * quantity)) {
            this.substract.disabled = true;
        } else {
            this.substract.removeAttribute('disabled');
        }

        if (this.value === (parseInt(this.max) * quantity)) {
            this.add.disabled = true;
        } else {
            this.add.removeAttribute('disabled');
        }
    }

    getQuantity(): number {
        let quantity: number = 1;

        if (parseInt(this.quantitymultiplier) > 1) {
            quantity = parseInt(this.quantitymultiplier);
        }

        return quantity;
    }
}

